module.exports = __webpack_public_path__ + "media/images/front/icon_movie_ar-ab3242dbb77cecbc8d4ace6882feec88.png";